var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicElement',{staticClass:"raw-html",class:[{ '-pre-line': _vm.preserveBreaks, '-align-left': _vm.alignLeft }],attrs:{"tag":_vm.tag}})
}
var staticRenderFns = []

export { render, staticRenderFns }